import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';
import type { CancelReasons } from './types';

type DetailKey = keyof Omit<CancelReasons, 'main_reason'>;

export const useCancelSubscriptionData = () => {
  const { t } = useI18n();

  const allData = [
    {
      key: 'dont_need_salonized',
      label: t(
        'subscription.cancelation_flow.form_label.dont_need_salonized',
        brandName(),
      ),
      options: [
        {
          label: t(
            'subscription.cancelation_flow.options.business_not_big_enough',
          ),
          value: 'business_not_big_enough',
        },
        {
          label: t('subscription.cancelation_flow.options.just_looking_around'),
          value: 'just_looking_around',
        },
        {
          label: t(
            'subscription.cancelation_flow.options.subscribed_by_mistake',
          ),
          value: 'subscribed_by_mistake',
        },
      ],
    },
    {
      key: 'doesnt_work_for_me',
      label: t(
        'subscription.cancelation_flow.form_label.doesnt_work_for_me',
        brandName(),
      ),
      options: [
        {
          label: t(
            'subscription.cancelation_flow.options.missing_important_features',
          ),
          value: 'missing_important_features',
        },
        {
          label: t(
            'subscription.cancelation_flow.options.customers_dont_get_it',
          ),
          value: 'customers_dont_get_it',
        },
        {
          label: t(
            'subscription.cancelation_flow.options.setup_is_too_complicated',
          ),
          value: 'setup_is_too_complicated',
        },
        {
          label: t(
            'subscription.cancelation_flow.options.bugs_and_technical_issues',
          ),
          value: 'bugs_and_technical_issues',
        },
      ],
    },
    {
      key: 'i_have_life_business_change',
      label: t(
        'subscription.cancelation_flow.form_label.i_have_life_business_change',
        brandName(),
      ),
      options: [
        {
          label: t('subscription.cancelation_flow.options.its_permanent'),
          value: 'its_permanent',
        },
        {
          label: t('subscription.cancelation_flow.options.its_temporary'),
          value: 'its_temporary',
        },
      ],
    },
    {
      key: 'its_too_expensive',
      label: t(
        'subscription.cancelation_flow.form_label.its_too_expensive',
        brandName(),
      ),
      options: [
        {
          label: t('subscription.cancelation_flow.options.pay_too_much'),
          value: 'pay_too_much',
        },
        {
          label: t(
            'subscription.cancelation_flow.options.needs_to_lower_business_costs',
          ),
          value: 'needs_to_lower_business_costs',
        },
      ],
    },
  ] satisfies ReadonlyArray<{
    key: DetailKey;
    label: string;
    options: { label: string; value: string }[];
  }>;

  const detailInit = Object.fromEntries(
    allData.map(({ key }) => [key, '']),
  ) as Record<DetailKey, string>;

  const cancelReasonData: CancelReasons = {
    main_reason: allData[0].key,
    ...detailInit,
    talk_to_sales: false,
  };

  return { allData, cancelReasonData };
};
